import {
  FETCHING_ACCOUNT_SUMMARY_REQUEST,
  FETCHING_ACCOUNT_SUMMARY_SUCCEDDED,
  FETCHING_ACCOUNT_SUMMARY_FAILED,
  FETCHING_DISCOVERY_CONTENT_MATRIX_REQUEST,
  FETCHING_DISCOVERY_CONTENT_MATRIX_SUCCEDDED,
  FETCHING_DISCOVERY_CONTENT_MATRIX_FAILED,
  FETCHING_DISCOVERY_ASSET_VIEWS_GRAPH_REPORT,
  FETCHING_DISCOVERY_ASSET_VIEWS_GRAPH_REPORT_SUCCEDDED,
  FETCHING_DISCOVERY_ASSET_VIEWS_GRAPH_REPORT_FAILED,
  FETCHING_DISCOVERY_ASSET_GRAPH_REPORT,
  FETCHING_DISCOVERY_ASSET_GRAPH_REPORT_SUCCEDDED,
  FETCHING_DISCOVERY_ASSET_GRAPH_REPORT_FAILED,
  FETCHING_DISCOVERY_TEAM_MEMBERS_GRAPH_REPORT,
  FETCHING_DISCOVERY_TEAM_MEMBERS_GRAPH_REPORT_SUCCEDDED,
  FETCHING_DISCOVERY_TEAM_MEMBERS_GRAPH_REPORT_FAILED,
  FETCHING_DISCOVERY_SHARE_GRAPH_REPORT,
  FETCHING_DISCOVERY_SHARE_GRAPH_REPORT_SUCCEDDED,
  FETCHING_DISCOVERY_SHARE_GRAPH_REPORT_FAILED,
  FETCHING_DISCOVERY_COLLECTION_ACTIVITY_GRAPH_REPORT,
  FETCHING_DISCOVERY_COLLECTION_ACTIVITY_GRAPH_REPORT_SUCCEDDED,
  FETCHING_DISCOVERY_COLLECTION_ACTIVITY_GRAPH_REPORT_FAILED,
  FETCHING_DISCOVERY_POPULAR_ASSETS,
  FETCHING_DISCOVERY_POPULAR_ASSETS_SUCCEDDED,
  FETCHING_DISCOVERY_POPULAR_ASSETS_FAILED,
  FETCHING_DISCOVERY_TOP_USERS,
  FETCHING_DISCOVERY_TOP_USERS_SUCCEDDED,
  FETCHING_DISCOVERY_TOP_USERS_FAILED,
  FETCHING_DISCOVERY_TOP_USER_GROUPS,
  FETCHING_DISCOVERY_TOP_USER_GROUPS_SUCCEDDED,
  FETCHING_DISCOVERY_TOP_USER_GROUPS_FAILED,
  FETCHING_DISCOVERY_SEARCH_QUERIES,
  FETCHING_DISCOVERY_SEARCH_QUERIES_SUCCEDDED,
  FETCHING_DISCOVERY_SEARCH_QUERIES_FAILED,
  FETCHING_DISCOVERY_SEARCH_TAGS,
  FETCHING_DISCOVERY_SEARCH_TAGS_SUCCEDDED,
  FETCHING_DISCOVERY_SEARCH_TAGS_FAILED,
  FETCHING_DISCOVERY_USER_ACTIVITIES,
  FETCHING_DISCOVERY_USER_ACTIVITIES_SUCCEDDED,
  FETCHING_DISCOVERY_USER_ACTIVITIES_FAILED,
  FETCHING_DISCOVERY_COLLECTIONS_REPORT,
  FETCHING_DISCOVERY_COLLECTIONS_REPORT_SUCCEDDED,
  FETCHING_DISCOVERY_COLLECTIONS_REPORT_FAILED,
  FETCHING_DISCOVERY_COLLECTIONS_SHARED_REPORT,
  FETCHING_DISCOVERY_COLLECTIONS_SHARED_REPORT_SUCCEDDED,
  FETCHING_DISCOVERY_COLLECTIONS_SHARED_REPORT_FAILED,
  FETCHING_ENGAGEMENT_ASSET_VIEWS_GRAPH_REPORT,
  FETCHING_ENGAGEMENT_ASSET_VIEWS_GRAPH_REPORT_SUCCEDDED,
  FETCHING_ENGAGEMENT_ASSET_VIEWS_GRAPH_REPORT_FAILED,
  FETCHING_ENGAGEMENT_SHARE_GRAPH_REPORT,
  FETCHING_ENGAGEMENT_SHARE_GRAPH_REPORT_SUCCEDDED,
  FETCHING_ENGAGEMENT_SHARE_GRAPH_REPORT_FAILED,
  FETCHING_ENGAGEMENT_UNIQUE_VIEWERS_GRAPH_REPORT,
  FETCHING_ENGAGEMENT_UNIQUE_VIEWERS_GRAPH_REPORT_SUCCEDDED,
  FETCHING_ENGAGEMENT_UNIQUE_VIEWERS_GRAPH_REPORT_FAILED,
  FETCHING_ENGAGEMENT_ATTENTION_TIME_GRAPH_REPORT,
  FETCHING_ENGAGEMENT_ATTENTION_TIME_GRAPH_REPORT_SUCCEDDED,
  FETCHING_ENGAGEMENT_ATTENTION_TIME_GRAPH_REPORT_FAILED,
  FETCHING_ENGAGEMENT_POPULAR_ASSETS,
  FETCHING_ENGAGEMENT_POPULAR_ASSETS_SUCCEDDED,
  FETCHING_ENGAGEMENT_POPULAR_ASSETS_FAILED,
  FETCHING_ENGAGEMENT_TOP_USERS,
  FETCHING_ENGAGEMENT_TOP_USERS_SUCCEDDED,
  FETCHING_ENGAGEMENT_TOP_USERS_FAILED,
  FETCHING_ENGAGEMENT_TOP_ACCOUNTS,
  FETCHING_ENGAGEMENT_TOP_ACCOUNTS_SUCCEDDED,
  FETCHING_ENGAGEMENT_TOP_ACCOUNTS_FAILED,
  FETCHING_ENGAGEMENT_TOP_CAMPAIGNS,
  FETCHING_ENGAGEMENT_TOP_CAMPAIGNS_SUCCEDDED,
  FETCHING_ENGAGEMENT_TOP_CAMPAIGNS_FAILED,
  FETCHING_ENGAGEMENT_TOP_CAMPAIGN_SOURCES,
  FETCHING_ENGAGEMENT_TOP_CAMPAIGN_SOURCES_SUCCEDDED,
  FETCHING_ENGAGEMENT_TOP_CAMPAIGN_SOURCES_FAILED,
  FETCHING_ENGAGEMENT_COLLECTION_ACTIVITIES,
  FETCHING_ENGAGEMENT_COLLECTION_ACTIVITIES_SUCCEDDED,
  FETCHING_ENGAGEMENT_COLLECTION_ACTIVITIES_FAILED,
  FETCHING_ENGAGEMENT_CONVERSATION_ACTIVITIES,
  FETCHING_ENGAGEMENT_CONVERSATION_ACTIVITIES_SUCCEDDED,
  FETCHING_ENGAGEMENT_CONVERSATION_ACTIVITIES_FAILED,
  INTIALIZING_DOWNLOAD_REPORT_REQUEST,
  INTIALIZING_DOWNLOAD_REPORT_SUCCEDDED,
  INTIALIZING_DOWNLOAD_REPORT_FAILED,
  FETCHING_DISCOVERY_CONTENT_MATRIX_ASSETS_REQUEST,
  FETCHING_DISCOVERY_CONTENT_MATRIX_ASSETS_SUCCEDDED,
  FETCHING_DISCOVERY_CONTENT_MATRIX_ASSETS_FAILED,
  INVALIDATE_DISCOVERY_CONTENT_MATRIX_ASSETS,
  FETCHING_PERFORMANCE_SUMMARY_REQUEST,
  FETCHING_PERFORMANCE_SUMMARY_SUCCEEDED,
  FETCHING_PERFORMANCE_SUMMARY_FAILED,
  FETCHING_PERFORMANCE_INTERACTIONS_GRAPH_REPORT,
  FETCHING_PERFORMANCE_INTERACTIONS_SUCCEEDED,
  FETCHING_PERFORMANCE_INTERACTIONS_FAILED,
  FETCHING_PERFORMANCE_LEADS_GRAPH_REPORT,
  FETCHING_PERFORMANCE_LEADS_SUCCEEDED,
  FETCHING_PERFORMANCE_LEADS_FAILED,
  FETCHING_PERFORMANCE_DEALS_GRAPH_REPORT,
  FETCHING_PERFORMANCE_DEALS_SUCCEEDED,
  FETCHING_PERFORMANCE_DEALS_FAILED,
  FETCHING_PERFORMANCE_DEAL_VALUE_GRAPH_REPORT,
  FETCHING_PERFORMANCE_DEAL_VALUE_SUCCEEDED,
  FETCHING_PERFORMANCE_DEAL_VALUE_FAILED,
  FETCHING_PERFORMANCE_CLOSED_DEALS_GRAPH_REPORT,
  FETCHING_PERFORMANCE_CLOSED_DEALS_SUCCEEDED,
  FETCHING_PERFORMANCE_CLOSED_DEALS_FAILED,
  FETCHING_PERFORMANCE_CLOSED_DEAL_VALUE_GRAPH_REPORT,
  FETCHING_PERFORMANCE_CLOSED_DEAL_VALUE_SUCCEEDED,
  FETCHING_PERFORMANCE_CLOSED_DEAL_VALUE_FAILED,
  FETCHING_PERFORMANCE_TOP_LEADS_CONTENT,
  FETCHING_PERFORMANCE_TOP_LEADS_CONTENT_SUCCEDDED,
  FETCHING_PERFORMANCE_TOP_LEADS_CONTENT_FAILED,
  FETCHING_PERFORMANCE_TOP_CONTENT_CLOSED_DEALS,
  FETCHING_PERFORMANCE_TOP_CONTENT_CLOSED_DEALS_SUCCEDDED,
  FETCHING_PERFORMANCE_TOP_CONTENT_CLOSED_DEALS_FAILED,
  FETCHING_DEALS_REQUEST_DETAIL_REPORT,
  FETCHING_DEALS_REQUEST_DETAIL_REPORT_SUCCEEDED,
  FETCHING_DEALS_REQUEST_DETAIL_REPORT_FAILED,
  FETCHING_CLOSED_DEALS_DETAIL_REPORT,
  FETCHING_CLOSED_DEALS_DETAIL_REPORT_SUCCEEDED,
  FETCHING_CLOSED_DEALS_DETAIL_REPORT_FAILED,
  FETCHING_LEADS_DETAIL_REPORT,
  FETCHING_LEADS_DETAIL_REPORT_SUCCEEDED,
  FETCHING_LEADS_DETAIL_REPORT_FAILED,
  UPDATE_FILTERS_IN_REPORTS,
  FETCH_ALL_FILTERS_REQUEST,
  FETCHING_ALL_FILTERS_SUCCEEDED,
  FETCHING_ALL_FILTERS_FAILED,
  SELECT_FILTER_REQUEST,
  FETCHING_DISCOVERY_TOP_SHARERS,
  FETCHING_DISCOVERY_TOP_SHARERS_SUCCEEDED,
  FETCHING_DISCOVERY_TOP_SHARERS_FAILED,
  FETCHING_DISCOVERY_ASSETS_SHARED_REPORT,
  FETCHING_DISCOVERY_ASSETS_SHARED_REPORT_SUCCEDDED,
  FETCHING_DISCOVERY_ASSETS_SHARED_REPORT_FAILED,
  FETCHING_ACCOUNT_SUMMARY_NUDGES_REQUEST,
  FETCHING_ACCOUNT_SUMMARY_NUDGES_SUCCEDDED,
  FETCHING_ACCOUNT_SUMMARY_NUDGES_FAILED,
  RESET_REPORT_DOWNLOAD,
} from "../actions/actionTypes";

import _ from "lodash";

var paginationState = {
  currentPage: 0,
  totalPages: 0,
  recordsPerPage: 1,
  totalRecordsCount: 0,
};

var downloadPaginationState = {
  currentPage: 0,
  totalPages: 0,
  recordsPerPage: 50,
  totalRecordsCount: 0,
};

const initialState = {
  summary: {
    loading: false,
    error: null,
    item: null,
  },
  reportSummary: {
    loading: false,
    error: null,
    item: null,
  },
  discovery: {
    contentMatrix: {
      loading: false,
      error: null,
      item: null,
    },
    assetViewsGraph: {
      loading: false,
      error: null,
      item: [],
    },
    assetsGraph: {
      loading: false,
      error: false,
      item: [],
    },
    teamMembersGraph: {
      loading: false,
      error: null,
      item: [],
    },
    sharesGraph: {
      loading: false,
      error: null,
      item: [],
    },
    collectionActivityGraph: {
      loading: false,
      error: null,
      item: [],
    },
    contentMatrixAssets: {
      loading: false,
      invalidated: true,
      items: [],
      pagination: {
        ...paginationState,
      },
    },
    popularAssets: {
      loading: false,
      invalidated: true,
      items: [],
      pagination: {
        ...paginationState,
      },
    },
    topUsers: {
      loading: false,
      invalidated: true,
      items: [],
      pagination: {
        ...paginationState,
      },
    },
    topUserGroups: {
      loading: false,
      invalidated: true,
      items: [],
      pagination: {
        ...paginationState,
      },
    },
    searchQueries: {
      loading: false,
      invalidated: true,
      items: [],
      pagination: {
        ...paginationState,
      },
    },
    searchTags: {
      loading: false,
      invalidated: true,
      items: [],
      pagination: {
        ...paginationState,
      },
    },
    userActivities: {
      loading: false,
      invalidated: true,
      items: [],
      pagination: {
        ...paginationState,
      },
    },
    collectionActivities: {
      loading: false,
      invalidated: true,
      items: [],
      pagination: {
        ...paginationState,
      },
    },
    conversationActivities: {
      loading: false,
      invalidated: true,
      items: [],
      pagination: {
        ...paginationState,
      },
    },
    collectionsCreated: {
      loading: false,
      invalidated: true,
      items: [],
      pagination: {
        ...paginationState,
      },
    },
    collectionsShared: {
      loading: false,
      invalidated: true,
      items: [],
      pagination: {
        ...paginationState,
      },
    },
    assetsShared: {
      loading: false,
      invalidated: true,
      items: [],
      pagination: {
        ...paginationState,
      },
    },
  },
  engagement: {
    assetViewsGraph: {
      loading: false,
      error: null,
      item: [],
    },
    sharesGraph: {
      loading: false,
      error: null,
      item: [],
    },
    uniqueViewers: {
      loading: false,
      error: null,
      item: [],
    },
    attentionTime: {
      loading: false,
      error: null,
      item: [],
    },
    popularAssets: {
      loading: false,
      invalidated: true,
      items: [],
      pagination: {
        ...paginationState,
      },
    },
    topUsers: {
      loading: false,
      invalidated: true,
      items: [],
      pagination: {
        ...paginationState,
      },
    },
    topAccounts: {
      loading: false,
      invalidated: true,
      items: [],
      pagination: {
        ...paginationState,
      },
    },
    campaigns: {
      loading: false,
      invalidated: true,
      items: [],
      pagination: {
        ...paginationState,
      },
    },
    campaignSources: {
      loading: false,
      invalidated: true,
      items: [],
      pagination: {
        ...paginationState,
      },
    },
  },
  performance: {
    performanceSummary: {
      loading: false,
      error: null,
      item: null,
    },
    interactions: {
      loading: false,
      error: null,
      item: [],
    },
    leads: {
      loading: false,
      error: null,
      item: [],
    },
    deals: {
      loading: false,
      error: null,
      item: [],
    },
    dealValue: {
      loading: false,
      error: null,
      item: [],
    },
    closedDeals: {
      loading: false,
      error: null,
      item: [],
    },
    closedDealValue: {
      loading: false,
      error: null,
      item: [],
    },
    topLeadsContent: {
      loading: false,
      invalidated: true,
      items: [],
      ...paginationState,
      loadMore: true,
    },
    contentClosedDeals: {
      loading: false,
      invalidated: true,
      items: [],
      ...paginationState,
      loadMore: true,
    },
    closedDealsDetail: {
      loading: false,
      invalidated: true,
      items: [],
      ...paginationState,
      loadMore: true,
    },
    dealsDetail: {
      loading: false,
      invalidated: true,
      items: [],
      ...paginationState,
      loadMore: true,
    },
    leadsDetail: {
      loading: false,
      invalidated: true,
      items: [],
      ...paginationState,
      loadMore: true,
    },
  },
  download: {
    downloading: false,
    invalidated: true,
    downloaded: false,
    items: [],
    pagination: {
      ...downloadPaginationState,
    },
    error: null,
  },
  selection: {},
  filters: {
    loading: false,
    invalidated: true,
    items: [],
    ...paginationState,
    loadMore: true,
    item: [],
  },
};

function reportReducer(state = initialState, action) {
  switch (action.type) {
    case FETCHING_ACCOUNT_SUMMARY_REQUEST:
      return Object.assign({}, state, {
        ...state,
        summary: {
          loading: true,
          error: null,
        },
      });

    case FETCHING_ACCOUNT_SUMMARY_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        summary: {
          loading: true,
          item: action.payload,
          error: null,
        },
      });

    case FETCHING_ACCOUNT_SUMMARY_FAILED:
      return Object.assign({}, state, {
        ...state,
        summary: {
          ...state.summary,
          loading: true,
          error: action.payload,
        },
      });

    case FETCHING_DISCOVERY_CONTENT_MATRIX_REQUEST:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          contentMatrix: {
            loading: true,
            error: null,
          },
        },
      });

    case FETCHING_DISCOVERY_CONTENT_MATRIX_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          contentMatrix: {
            loading: false,
            error: null,
            item: action.payload,
          },
        },
      });

    case FETCHING_DISCOVERY_CONTENT_MATRIX_FAILED:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          contentMatrix: {
            loading: false,
            error: action.payload,
            item: null,
          },
        },
      });

    case FETCHING_DISCOVERY_ASSET_VIEWS_GRAPH_REPORT:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          assetViewsGraph: {
            loading: true,
            error: null,
            item: [],
          },
        },
      });

    case FETCHING_DISCOVERY_ASSET_VIEWS_GRAPH_REPORT_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          assetViewsGraph: {
            loading: false,
            error: null,
            item: action.payload,
          },
        },
      });

    case FETCHING_DISCOVERY_ASSET_VIEWS_GRAPH_REPORT_FAILED:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          assetViewsGraph: {
            loading: false,
            error: action.payload,
            item: [],
          },
        },
      });

    case FETCHING_DISCOVERY_ASSET_GRAPH_REPORT:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          assetsGraph: {
            loading: true,
            error: null,
            item: [],
          },
        },
      });

    case FETCHING_DISCOVERY_ASSET_GRAPH_REPORT_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          assetsGraph: {
            loading: false,
            error: null,
            item: action.payload,
          },
        },
      });

    case FETCHING_DISCOVERY_ASSET_GRAPH_REPORT_FAILED:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          assetsGraph: {
            loading: false,
            error: action.payload,
            item: [],
          },
        },
      });

    case FETCHING_DISCOVERY_TEAM_MEMBERS_GRAPH_REPORT:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          teamMembersGraph: {
            loading: true,
            error: null,
            item: [],
          },
        },
      });

    case FETCHING_DISCOVERY_TEAM_MEMBERS_GRAPH_REPORT_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          teamMembersGraph: {
            loading: false,
            error: null,
            item: action.payload,
          },
        },
      });

    case FETCHING_DISCOVERY_TEAM_MEMBERS_GRAPH_REPORT_FAILED:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          teamMembersGraph: {
            loading: false,
            error: action.payload,
            item: [],
          },
        },
      });

    case FETCHING_DISCOVERY_SHARE_GRAPH_REPORT:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          sharesGraph: {
            loading: true,
            error: null,
            item: [],
          },
        },
      });

    case FETCHING_DISCOVERY_SHARE_GRAPH_REPORT_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          sharesGraph: {
            loading: false,
            error: null,
            item: action.payload,
          },
        },
      });

    case FETCHING_DISCOVERY_SHARE_GRAPH_REPORT_FAILED:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          sharesGraph: {
            loading: false,
            error: action.payload,
            item: [],
          },
        },
      });

    case FETCHING_DISCOVERY_COLLECTION_ACTIVITY_GRAPH_REPORT:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          collectionActivityGraph: {
            loading: true,
            error: null,
            item: [],
          },
        },
      });

    case FETCHING_DISCOVERY_COLLECTION_ACTIVITY_GRAPH_REPORT_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          collectionActivityGraph: {
            loading: false,
            error: null,
            item: action.payload,
          },
        },
      });

    case FETCHING_DISCOVERY_COLLECTION_ACTIVITY_GRAPH_REPORT_FAILED:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          collectionActivityGraph: {
            loading: false,
            error: action.payload,
            item: [],
          },
        },
      });

    case FETCHING_DISCOVERY_CONTENT_MATRIX_ASSETS_REQUEST:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          contentMatrixAssets: {
            ...state.discovery.contentMatrixAssets,
            loading: true,
            invalidated: false,
          },
        },
      });

    case FETCHING_DISCOVERY_CONTENT_MATRIX_ASSETS_SUCCEDDED:
      var items = [];

      if (action.payload.currentPage !== 0) {
        items = [
          ...state.discovery.contentMatrixAssets.items,
          ...action.payload.records,
        ];
      } else {
        items = action.payload.records;
      }

      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          contentMatrixAssets: {
            ...state.discovery.contentMatrixAssets,
            loading: false,
            invalidated: false,
            items: items,
            pagination: {
              currentPage: action.payload.currentPage,
              totalPages: action.payload.totalPages,
              recordsPerPage: action.payload.recordsPerPage,
              totalRecordsCount: action.payload.totalRecordsCount,
            },
          },
        },
      });

    case FETCHING_DISCOVERY_CONTENT_MATRIX_ASSETS_FAILED:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          contentMatrixAssets: {
            ...state.discovery.contentMatrixAssets,
            loading: false,
            invalidated: false,
            error: action.payload.error,
          },
        },
      });
    case INVALIDATE_DISCOVERY_CONTENT_MATRIX_ASSETS:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          contentMatrixAssets: {
            ...state.discovery.contentMatrixAssets,
            loading: false,
            invalidated: true,
            items: [],
            currentPage: 0,
            totalPages: 0,
            recordsPerPage: 0,
            loadMore: true,
          },
        },
      });

    case FETCHING_DISCOVERY_POPULAR_ASSETS:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          popularAssets: {
            ...state.discovery.popularAssets,
            loading: true,
            invalidated: true,
          },
        },
      });

    case FETCHING_DISCOVERY_POPULAR_ASSETS_SUCCEDDED:
      var records = action.payload.records;
      var items = [];

      if (action.payload.currentPage !== 0) {
        items = [
          ...state.discovery.popularAssets.items,
          ...action.payload.records,
        ];
      } else {
        items = action.payload.records;
      }

      items = _.uniqBy(items, "asset.id");

      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          popularAssets: {
            ...state.discovery.popularAssets,
            loading: false,
            invalidated: false,
            items: items,
            pagination: {
              currentPage: action.payload.currentPage,
              totalPages: action.payload.totalPages,
              recordsPerPage: action.payload.recordsPerPage,
              totalRecordsCount: action.payload.totalRecordsCount,
            },
          },
        },
      });

    case FETCHING_DISCOVERY_POPULAR_ASSETS_FAILED:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          popularAssets: {
            ...state.discovery.popularAssets,
            loading: false,
            invalidated: false,
            error: action.payload.error,
          },
        },
      });

    case FETCHING_DISCOVERY_TOP_USERS:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          topUsers: {
            ...state.discovery.topUsers,
            loading: true,
            invalidated: true,
          },
        },
      });

    case FETCHING_DISCOVERY_TOP_USERS_SUCCEDDED:
      var loadMore = action.payload.currentPage <= action.payload.totalPages;
      var records = action.payload.records;
      var items = [];

      if (action.payload.currentPage !== 0) {
        items = [...state.discovery.topUsers.items, ...action.payload.records];
      } else {
        items = action.payload.records;
      }

      items = _.uniqBy(items, "user.id");

      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          topUsers: {
            ...state.discovery.topUsers,
            loading: false,
            invalidated: false,
            items: items,
            pagination: {
              currentPage: action.payload.currentPage,
              totalPages: action.payload.totalPages,
              recordsPerPage: action.payload.recordsPerPage,
              totalRecordsCount: action.payload.totalRecordsCount,
            },
          },
        },
      });

    case FETCHING_DISCOVERY_TOP_USERS_FAILED:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          topUsers: {
            ...state.discovery.topUsers,
            loading: false,
            invalidated: false,
            error: action.payload.error,
          },
        },
      });

    case FETCHING_DISCOVERY_TOP_USER_GROUPS:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          topUserGroups: {
            ...state.discovery.topUserGroups,
            loading: true,
            invalidated: true,
          },
        },
      });

    case FETCHING_DISCOVERY_TOP_USER_GROUPS_SUCCEDDED:
      var loadMore = action.payload.currentPage <= action.payload.totalPages;
      var records = action.payload.records;
      var items = [];

      if (action.payload.currentPage !== 0) {
        items = [
          ...state.discovery.topUserGroups.items,
          ...action.payload.records,
        ];
      } else {
        items = action.payload.records;
      }

      items = _.uniqBy(items, "userGroup.id");

      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          topUserGroups: {
            ...state.discovery.topUserGroups,
            loading: false,
            invalidated: false,
            items: items,
            pagination: {
              currentPage: action.payload.currentPage,
              totalPages: action.payload.totalPages,
              recordsPerPage: action.payload.recordsPerPage,
              totalRecordsCount: action.payload.totalRecordsCount,
            },
          },
        },
      });

    case FETCHING_DISCOVERY_TOP_USER_GROUPS_FAILED:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          topUserGroups: {
            ...state.discovery.topUserGroups,
            loading: false,
            invalidated: false,
            error: action.payload.error,
          },
        },
      });

    case FETCHING_DISCOVERY_COLLECTIONS_REPORT:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          collectionsCreated: {
            ...state.discovery.collectionsCreated,
            loading: true,
            invalidated: true,
          },
        },
      });

    case FETCHING_DISCOVERY_COLLECTIONS_REPORT_SUCCEDDED:
      var loadMore = action.payload.currentPage <= action.payload.totalPages;
      var records = action.payload.records;
      var items = [];

      if (action.payload.currentPage !== 0) {
        items = [
          ...state.discovery.collectionsCreated.items,
          ...action.payload.records,
        ];
      } else {
        items = action.payload.records;
      }

      items = _.uniqBy(items, "collection.id");

      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          collectionsCreated: {
            ...state.discovery.collectionsCreated,
            loading: false,
            invalidated: false,
            items: items,
            pagination: {
              currentPage: action.payload.currentPage,
              totalPages: action.payload.totalPages,
              recordsPerPage: action.payload.recordsPerPage,
              totalRecordsCount: action.payload.totalRecordsCount,
            },
          },
        },
      });

    case FETCHING_DISCOVERY_COLLECTIONS_REPORT_FAILED:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          collectionsCreated: {
            ...state.discovery.collectionsCreated,
            loading: false,
            invalidated: false,
            error: action.payload.error,
          },
        },
      });

    case FETCHING_DISCOVERY_COLLECTIONS_SHARED_REPORT:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          collectionsShared: {
            ...state.discovery.collectionsShared,
            loading: true,
            invalidated: true,
          },
        },
      });

    case FETCHING_DISCOVERY_COLLECTIONS_SHARED_REPORT_SUCCEDDED:
      var loadMore = action.payload.currentPage <= action.payload.totalPages;
      var records = action.payload.records;
      var items = [];

      if (action.payload.currentPage !== 0) {
        items = [
          ...state.discovery.collectionsShared.items,
          ...action.payload.records,
        ];
      } else {
        items = action.payload.records;
      }

      items = _.uniqBy(items, "collection.id");

      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          collectionsShared: {
            ...state.discovery.collectionsShared,
            loading: false,
            invalidated: false,
            items: items,
            pagination: {
              currentPage: action.payload.currentPage,
              totalPages: action.payload.totalPages,
              recordsPerPage: action.payload.recordsPerPage,
              totalRecordsCount: action.payload.totalRecordsCount,
            },
          },
        },
      });

    case FETCHING_DISCOVERY_COLLECTIONS_SHARED_REPORT_FAILED:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          collectionsShared: {
            ...state.discovery.collectionsShared,
            loading: false,
            invalidated: false,
            error: action.payload.error,
          },
        },
      });

    case FETCHING_DISCOVERY_ASSETS_SHARED_REPORT:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          assetsShared: {
            ...state.discovery.assetsShared,
            loading: true,
            invalidated: true,
          },
        },
      });

    case FETCHING_DISCOVERY_ASSETS_SHARED_REPORT_SUCCEDDED:
      var loadMore = action.payload.currentPage <= action.payload.totalPages;
      var records = action.payload.records;
      var items = [];

      if (records == null) {
        return;
      }

      if (action.payload.currentPage !== 0) {
        items = [
          ...state.discovery.assetsShared.items,
          ...action.payload.records,
        ];
      } else {
        items = action.payload.records;
      }

      items = _.uniqBy(items, "asset.id");

      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          assetsShared: {
            ...state.discovery.assetsShared,
            loading: false,
            invalidated: false,
            items: items,
            pagination: {
              currentPage: action.payload.currentPage,
              totalPages: action.payload.totalPages,
              recordsPerPage: action.payload.recordsPerPage,
              totalRecordsCount: action.payload.totalRecordsCount,
            },
          },
        },
      });

    case FETCHING_DISCOVERY_ASSETS_SHARED_REPORT_FAILED:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          assetsShared: {
            ...state.discovery.assetsShared,
            loading: false,
            invalidated: false,
            error: action.payload.error,
          },
        },
      });

    case FETCHING_DISCOVERY_TOP_SHARERS:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          topSharers: {
            ...state.discovery.topSharers,
            loading: true,
            invalidated: true,
          },
        },
      });

    case FETCHING_DISCOVERY_TOP_SHARERS_SUCCEEDED:
      var loadMore = action.payload.currentPage <= action.payload.totalPages;
      var records = action.payload.records;
      var items = [];

      if (action.payload.currentPage !== 0) {
        items = [
          ...state.discovery.topSharers.items,
          ...action.payload.records,
        ];
      } else {
        items = action.payload.records;
      }

      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          topSharers: {
            ...state.discovery.topSharers,
            loading: false,
            invalidated: false,
            items: items,
            pagination: {
              currentPage: action.payload.currentPage,
              totalPages: action.payload.totalPages,
              recordsPerPage: action.payload.recordsPerPage,
              totalRecordsCount: action.payload.totalRecordsCount,
            },
          },
        },
      });

    case FETCHING_DISCOVERY_TOP_SHARERS_FAILED:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          topSharers: {
            ...state.discovery.topSharers,
            loading: false,
            invalidated: false,
            error: action.payload.error,
          },
        },
      });

    case FETCHING_DISCOVERY_SEARCH_QUERIES:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          searchQueries: {
            ...state.discovery.searchQueries,
            loading: true,
            invalidated: true,
          },
        },
      });

    case FETCHING_DISCOVERY_SEARCH_QUERIES_SUCCEDDED:
      var records = action.payload.records;
      var items = [];

      if (action.payload.currentPage !== 0) {
        items = [
          ...state.discovery.searchQueries.items,
          ...action.payload.records,
        ];
      } else {
        items = action.payload.records;
      }

      items = _.uniqBy(items, "query");

      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          searchQueries: {
            ...state.discovery.searchQueries,
            loading: false,
            invalidated: false,
            items: items,
            pagination: {
              currentPage: action.payload.currentPage,
              totalPages: action.payload.totalPages,
              recordsPerPage: action.payload.recordsPerPage,
              totalRecordsCount: action.payload.totalRecordsCount,
            },
          },
        },
      });

    case FETCHING_DISCOVERY_SEARCH_QUERIES_FAILED:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          searchQueries: {
            ...state.discovery.searchQueries,
            loading: false,
            invalidated: false,
            error: action.payload.error,
          },
        },
      });

    case FETCHING_DISCOVERY_SEARCH_TAGS:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          searchTags: {
            ...state.discovery.searchTags,
            loading: true,
            invalidated: true,
          },
        },
      });

    case FETCHING_DISCOVERY_SEARCH_TAGS_SUCCEDDED:
      var items = [];

      if (action.payload.currentPage !== 0) {
        items = [
          ...state.discovery.searchTags.items,
          ...action.payload.records,
        ];
      } else {
        items = action.payload.records;
      }

      items = _.uniqBy(items, "key");

      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          searchTags: {
            ...state.discovery.searchTags,
            loading: false,
            invalidated: false,
            items: items,
            pagination: {
              currentPage: action.payload.currentPage,
              totalPages: action.payload.totalPages,
              recordsPerPage: action.payload.recordsPerPage,
              totalRecordsCount: action.payload.totalRecordsCount,
            },
          },
        },
      });

    case FETCHING_DISCOVERY_SEARCH_TAGS_FAILED:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          searchTags: {
            ...state.discovery.searchTags,
            loading: false,
            invalidated: false,
            error: action.payload.error,
          },
        },
      });

    case FETCHING_DISCOVERY_USER_ACTIVITIES:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          userActivities: {
            ...state.discovery.userActivities,
            loading: true,
            invalidated: true,
          },
        },
      });

    case FETCHING_DISCOVERY_USER_ACTIVITIES_SUCCEDDED:
      var records = action.payload.records;
      var items = [];

      if (action.payload.currentPage !== 0) {
        items = [
          ...state.discovery.userActivities.items,
          ...action.payload.records,
        ];
      } else {
        items = action.payload.records;
      }

      var loadMore = action.payload.currentPage <= action.payload.totalPages;

      items = items.reduce((x, y) => {
        var index = x.findIndex((e) => {
          return e.user.id == y.user.id;
        });

        if (index < 0) {
          return [...x, y];
        } else {
          x[index] = y;
          return x;
        }
      }, []);

      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          userActivities: {
            ...state.discovery.userActivities,
            loading: false,
            invalidated: false,
            items: items,
            currentPage: action.payload.currentPage + 1,
            totalPages: action.payload.totalPages,
            recordsPerPage: action.payload.recordsPerPage,
            totalRecordsCount: action.payload.totalRecordsCount,
            loadMore: loadMore,
          },
        },
      });

    case FETCHING_DISCOVERY_USER_ACTIVITIES_FAILED:
      return Object.assign({}, state, {
        ...state,
        discovery: {
          ...state.discovery,
          userActivities: {
            ...state.discovery.userActivities,
            loading: false,
            invalidated: false,
            error: action.payload.error,
            currentPage: state.discovery.userActivities.currentPage,
            totalPages: state.discovery.userActivities.totalPages,
            recordsPerPage: state.discovery.userActivities.recordsPerPage,
            totalRecordsCount: state.discovery.userActivities.totalRecordsCount,
            loadMore: true,
          },
        },
      });

    case FETCHING_ENGAGEMENT_ASSET_VIEWS_GRAPH_REPORT:
      return Object.assign({}, state, {
        ...state,
        engagement: {
          ...state.engagement,
          assetViewsGraph: {
            loading: true,
            error: null,
            item: [],
          },
        },
      });

    case FETCHING_ENGAGEMENT_ASSET_VIEWS_GRAPH_REPORT_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        engagement: {
          ...state.engagement,
          assetViewsGraph: {
            loading: false,
            error: null,
            item: action.payload,
          },
        },
      });
    case FETCHING_ENGAGEMENT_ASSET_VIEWS_GRAPH_REPORT_FAILED:
      return Object.assign({}, state, {
        ...state,
        engagement: {
          ...state.engagement,
          assetViewsGraph: {
            loading: false,
            error: action.payload,
            item: [],
          },
        },
      });
    case FETCHING_ENGAGEMENT_SHARE_GRAPH_REPORT:
      return Object.assign({}, state, {
        ...state,
        engagement: {
          ...state.engagement,
          sharesGraph: {
            loading: true,
            error: null,
            item: [],
          },
        },
      });

    case FETCHING_ENGAGEMENT_SHARE_GRAPH_REPORT_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        engagement: {
          ...state.engagement,
          sharesGraph: {
            loading: false,
            error: null,
            item: action.payload,
          },
        },
      });
    case FETCHING_ENGAGEMENT_SHARE_GRAPH_REPORT_FAILED:
      return Object.assign({}, state, {
        ...state,
        engagement: {
          ...state.engagement,
          sharesGraph: {
            loading: false,
            error: action.payload,
            item: [],
          },
        },
      });
    case FETCHING_ENGAGEMENT_UNIQUE_VIEWERS_GRAPH_REPORT:
      return Object.assign({}, state, {
        ...state,
        engagement: {
          ...state.engagement,
          uniqueViewers: {
            loading: true,
            error: null,
            item: [],
          },
        },
      });

    case FETCHING_ENGAGEMENT_UNIQUE_VIEWERS_GRAPH_REPORT_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        engagement: {
          ...state.engagement,
          uniqueViewers: {
            loading: false,
            error: null,
            item: action.payload,
          },
        },
      });

    case FETCHING_ENGAGEMENT_UNIQUE_VIEWERS_GRAPH_REPORT_FAILED:
      return Object.assign({}, state, {
        ...state,
        engagement: {
          ...state.engagement,
          uniqueViewers: {
            loading: false,
            error: action.payload,
            item: [],
          },
        },
      });
    case FETCHING_ENGAGEMENT_ATTENTION_TIME_GRAPH_REPORT:
      return Object.assign({}, state, {
        ...state,
        engagement: {
          ...state.engagement,
          attentionTime: {
            loading: true,
            error: null,
            item: [],
          },
        },
      });
    case FETCHING_ENGAGEMENT_ATTENTION_TIME_GRAPH_REPORT_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        engagement: {
          ...state.engagement,
          attentionTime: {
            loading: false,
            error: null,
            item: action.payload,
          },
        },
      });

    case FETCHING_ENGAGEMENT_ATTENTION_TIME_GRAPH_REPORT_FAILED:
      return Object.assign({}, state, {
        ...state,
        engagement: {
          ...state.engagement,
          attentionTime: {
            loading: false,
            error: action.payload,
            item: [],
          },
        },
      });

    case FETCHING_ENGAGEMENT_POPULAR_ASSETS:
      return Object.assign({}, state, {
        ...state,
        engagement: {
          ...state.engagement,
          popularAssets: {
            ...state.engagement.popularAssets,
            loading: true,
            invalidated: true,
          },
        },
      });

    case FETCHING_ENGAGEMENT_POPULAR_ASSETS_SUCCEDDED:
      var loadMore = action.payload.currentPage <= action.payload.totalPages;

      var items = [];

      if (action.payload.currentPage !== 0) {
        items = [
          ...state.engagement.popularAssets.items,
          ...action.payload.records,
        ];
      } else {
        items = action.payload.records;
      }

      items = _.uniqBy(items, "asset.id");

      return Object.assign({}, state, {
        ...state,
        engagement: {
          ...state.engagement,
          popularAssets: {
            ...state.engagement.popularAssets,
            loading: false,
            invalidated: false,
            items: items,
            pagination: {
              currentPage: action.payload.currentPage,
              totalPages: action.payload.totalPages,
              recordsPerPage: action.payload.recordsPerPage,
              totalRecordsCount: action.payload.totalRecordsCount,
            },
          },
        },
      });

    case FETCHING_ENGAGEMENT_POPULAR_ASSETS_FAILED:
      return Object.assign({}, state, {
        ...state,
        engagement: {
          ...state.engagement,
          popularAssets: {
            ...state.engagement.popularAssets,
            loading: false,
            invalidated: false,
            error: action.payload.error,
            currentPage: state.engagement.popularAssets.currentPage,
            totalPages: state.engagement.popularAssets.totalPages,
            recordsPerPage: state.engagement.popularAssets.recordsPerPage,
            totalRecordsCount: state.engagement.popularAssets.totalRecordsCount,
            loadMore: true,
          },
        },
      });
    case FETCHING_ENGAGEMENT_TOP_USERS:
      return Object.assign({}, state, {
        ...state,
        engagement: {
          ...state.engagement,
          topUsers: {
            ...state.engagement.topUsers,
            loading: true,
            invalidated: true,
          },
        },
      });

    case FETCHING_ENGAGEMENT_TOP_USERS_SUCCEDDED:
      var loadMore = action.payload.currentPage <= action.payload.totalPages;

      var items = [];

      if (action.payload.currentPage !== 0) {
        items = [...state.engagement.topUsers.items, ...action.payload.records];
      } else {
        items = action.payload.records;
      }

      items = _.uniqBy(items, "contact.id");

      return Object.assign({}, state, {
        ...state,
        engagement: {
          ...state.engagement,
          topUsers: {
            ...state.engagement.topUsers,
            loading: false,
            invalidated: false,
            items: items,
            pagination: {
              currentPage: action.payload.currentPage,
              totalPages: action.payload.totalPages,
              recordsPerPage: action.payload.recordsPerPage,
              totalRecordsCount: action.payload.totalRecordsCount,
            },
          },
        },
      });

    case FETCHING_ENGAGEMENT_TOP_USERS_FAILED:
      return Object.assign({}, state, {
        ...state,
        engagement: {
          ...state.engagement,
          topUsers: {
            ...state.engagement.topUsers,
            loading: false,
            invalidated: false,
            error: action.payload.error,
            currentPage: state.engagement.topUsers.currentPage,
            totalPages: state.engagement.topUsers.totalPages,
            recordsPerPage: state.engagement.topUsers.recordsPerPage,
            totalRecordsCount: state.engagement.topUsers.totalRecordsCount,
            loadMore: true,
          },
        },
      });
    case FETCHING_ENGAGEMENT_TOP_ACCOUNTS:
      return Object.assign({}, state, {
        ...state,
        engagement: {
          ...state.engagement,
          topAccounts: {
            ...state.engagement.topAccounts,
            loading: true,
            invalidated: true,
          },
        },
      });

    case FETCHING_ENGAGEMENT_TOP_ACCOUNTS_SUCCEDDED:
      var loadMore = action.payload.currentPage <= action.payload.totalPages;

      var items = [];

      if (action.payload.currentPage !== 0) {
        items = [
          ...state.engagement.topAccounts.items,
          ...action.payload.records,
        ];
      } else {
        items = action.payload.records;
      }

      items = _.uniqBy(items, "company");

      return Object.assign({}, state, {
        ...state,
        engagement: {
          ...state.engagement,
          topAccounts: {
            ...state.engagement.topAccounts,
            loading: false,
            invalidated: false,
            items: items,
            pagination: {
              currentPage: action.payload.currentPage,
              totalPages: action.payload.totalPages,
              recordsPerPage: action.payload.recordsPerPage,
              totalRecordsCount: action.payload.totalRecordsCount,
            },
          },
        },
      });

    case FETCHING_ENGAGEMENT_TOP_ACCOUNTS_FAILED:
      return Object.assign({}, state, {
        ...state,
        engagement: {
          ...state.engagement,
          topAccounts: {
            ...state.engagement.topAccounts,
            loading: false,
            invalidated: false,
            error: action.payload.error,
            currentPage: state.engagement.topAccounts.currentPage,
            totalPages: state.engagement.topAccounts.totalPages,
            recordsPerPage: state.engagement.topAccounts.recordsPerPage,
            totalRecordsCount: state.engagement.topAccounts.totalRecordsCount,
            loadMore: true,
          },
        },
      });
    case FETCHING_ENGAGEMENT_TOP_CAMPAIGNS:
      return Object.assign({}, state, {
        ...state,
        engagement: {
          ...state.engagement,
          campaigns: {
            ...state.engagement.campaigns,
            loading: true,
            invalidated: true,
          },
        },
      });

    case FETCHING_ENGAGEMENT_TOP_CAMPAIGNS_SUCCEDDED:
      var loadMore = action.payload.currentPage <= action.payload.totalPages;

      var items = [];

      if (action.payload.currentPage !== 0) {
        items = [
          ...state.engagement.campaigns.items,
          ...action.payload.records,
        ];
      } else {
        items = action.payload.records;
      }

      items = _.uniqBy(items, "name");

      return Object.assign({}, state, {
        ...state,
        engagement: {
          ...state.engagement,
          campaigns: {
            ...state.engagement.campaigns,
            loading: false,
            invalidated: false,
            items: items,
            pagination: {
              currentPage: action.payload.currentPage,
              totalPages: action.payload.totalPages,
              recordsPerPage: action.payload.recordsPerPage,
              totalRecordsCount: action.payload.totalRecordsCount,
            },
          },
        },
      });

    case FETCHING_ENGAGEMENT_TOP_CAMPAIGNS_FAILED:
      return Object.assign({}, state, {
        ...state,
        engagement: {
          ...state.engagement,
          campaigns: {
            ...state.engagement.campaigns,
            loading: false,
            invalidated: false,
            error: action.payload.error,
            currentPage: state.engagement.campaigns.currentPage,
            totalPages: state.engagement.campaigns.totalPages,
            recordsPerPage: state.engagement.campaigns.recordsPerPage,
            totalRecordsCount: state.engagement.campaigns.totalRecordsCount,
            loadMore: true,
          },
        },
      });
    case FETCHING_ENGAGEMENT_TOP_CAMPAIGN_SOURCES:
      return Object.assign({}, state, {
        ...state,
        engagement: {
          ...state.engagement,
          campaignSources: {
            ...state.engagement.campaignSources,
            loading: true,
            invalidated: true,
          },
        },
      });

    case FETCHING_ENGAGEMENT_TOP_CAMPAIGN_SOURCES_SUCCEDDED:
      var loadMore = action.payload.currentPage <= action.payload.totalPages;

      var items = [];

      if (action.payload.currentPage !== 0) {
        items = [
          ...state.engagement.campaignSources.items,
          ...action.payload.records,
        ];
      } else {
        items = action.payload.records;
      }

      items = _.uniqBy(items, "name");

      return Object.assign({}, state, {
        ...state,
        engagement: {
          ...state.engagement,
          campaignSources: {
            ...state.engagement.campaignSources,
            loading: false,
            invalidated: false,
            items: items,
            pagination: {
              currentPage: action.payload.currentPage,
              totalPages: action.payload.totalPages,
              recordsPerPage: action.payload.recordsPerPage,
              totalRecordsCount: action.payload.totalRecordsCount,
            },
          },
        },
      });

    case FETCHING_ENGAGEMENT_TOP_CAMPAIGN_SOURCES_FAILED:
      return Object.assign({}, state, {
        ...state,
        engagement: {
          ...state.engagement,
          campaignSources: {
            ...state.engagement.campaignSources,
            loading: false,
            invalidated: false,
            error: action.payload.error,
            currentPage: state.engagement.campaignSources.currentPage,
            totalPages: state.engagement.campaignSources.totalPages,
            recordsPerPage: state.engagement.campaignSources.recordsPerPage,
            totalRecordsCount:
              state.engagement.campaignSources.totalRecordsCount,
            loadMore: true,
          },
        },
      });

    case FETCHING_ENGAGEMENT_COLLECTION_ACTIVITIES:
      return Object.assign({}, state, {
        ...state,
        engagement: {
          ...state.engagement,
          collectionActivities: {
            ...state.engagement.collectionActivities,
            loading: true,
            invalidated: true,
          },
        },
      });

    case FETCHING_ENGAGEMENT_COLLECTION_ACTIVITIES_SUCCEDDED:
      var items = [];

      if (action.payload.currentPage !== 0) {
        items = [
          ...state.engagement.collectionActivities.items,
          ...action.payload.records,
        ];
      } else {
        items = action.payload.records;
      }

      items = _.uniqBy(items, "collection.id");

      return Object.assign({}, state, {
        ...state,
        engagement: {
          ...state.engagement,
          collectionActivities: {
            ...state.engagement.collectionActivities,
            loading: false,
            invalidated: false,
            items: items,
            pagination: {
              currentPage: action.payload.currentPage,
              totalPages: action.payload.totalPages,
              recordsPerPage: action.payload.recordsPerPage,
              totalRecordsCount: action.payload.totalRecordsCount,
            },
          },
        },
      });

    case FETCHING_ENGAGEMENT_COLLECTION_ACTIVITIES_FAILED:
      return Object.assign({}, state, {
        ...state,
        engagement: {
          ...state.engagement,
          collectionActivities: {
            ...state.engagement.collectionActivities,
            loading: false,
            invalidated: false,
            error: action.payload.error,
          },
        },
      });

    case FETCHING_ENGAGEMENT_CONVERSATION_ACTIVITIES:
      return Object.assign({}, state, {
        ...state,
        engagement: {
          ...state.engagement,
          conversationActivities: {
            ...state.engagement.conversationActivities,
            loading: true,
            invalidated: true,
          },
        },
      });

    case FETCHING_ENGAGEMENT_CONVERSATION_ACTIVITIES_SUCCEDDED:
      var items = [];

      if (action.payload.currentPage !== 0) {
        items = [
          ...state.engagement.conversationActivities.items,
          ...action.payload.records,
        ];
      } else {
        items = action.payload.records;
      }

      items = _.uniqBy(items, "share.id");

      return Object.assign({}, state, {
        ...state,
        engagement: {
          ...state.engagement,
          conversationActivities: {
            ...state.engagement.conversationActivities,
            loading: false,
            invalidated: false,
            items: items,
            pagination: {
              currentPage: action.payload.currentPage,
              totalPages: action.payload.totalPages,
              recordsPerPage: action.payload.recordsPerPage,
              totalRecordsCount: action.payload.totalRecordsCount,
            },
          },
        },
      });

    case FETCHING_ENGAGEMENT_CONVERSATION_ACTIVITIES_FAILED:
      return Object.assign({}, state, {
        ...state,
        engagement: {
          ...state.engagement,
          conversationActivities: {
            ...state.engagement.conversationActivities,
            loading: false,
            invalidated: false,
            error: action.payload.error,
          },
        },
      });

    case INTIALIZING_DOWNLOAD_REPORT_REQUEST: {
      const { page } = action.payload;

      let items = state.download.items;

      if (page === 0) {
        items = [];
      }

      return Object.assign({}, state, {
        ...state,
        download: {
          downloading: true,
          downloaded: false,
          items: items,

          error: null,
        },
      });
    }

    case INTIALIZING_DOWNLOAD_REPORT_SUCCEDDED: {
      let result = action.payload;

      var items = [];
      if (result.currentPage === 0) {
        items = result.records;
      } else {
        items = [...state.download.items, ...result.records];
      }

      var downloading = result.currentPage + 1 < result.totalPages;

      return Object.assign({}, state, {
        ...state,
        download: {
          downloading: downloading,
          downloaded: !downloading,
          items: items,
          pagination: {
            currentPage: result.currentPage,
            totalPages: result.totalPages,
            recordsPerPage: result.recordsPerPage,
            totalRecordsCount: result.totalRecordsCount,
          },
          error: null,
        },
      });
    }

    case INTIALIZING_DOWNLOAD_REPORT_FAILED: {
      return Object.assign({}, state, {
        ...state,
        download: {
          downloading: false,
          downloaded: false,
          items: [],
          pagination: {
            ...downloadPaginationState,
          },
          error: action.payload,
        },
      });
    }

    case RESET_REPORT_DOWNLOAD:
      return Object.assign({}, state, {
        ...state,
        download: {
          downloading: false,
          invalidated: true,
          downloaded: false,
          items: [],
          pagination: {
            ...downloadPaginationState,
          },
          error: null,
        }
      });

    case FETCHING_PERFORMANCE_INTERACTIONS_GRAPH_REPORT:
      return Object.assign({}, state, {
        ...state,
        performance: {
          ...state.performance,
          interactions: {
            loading: true,
            error: null,
            item: [],
          },
        },
      });

    case FETCHING_PERFORMANCE_INTERACTIONS_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        performance: {
          ...state.performance,
          interactions: {
            loading: false,
            error: null,
            item: action.payload,
          },
        },
      });
    case FETCHING_PERFORMANCE_INTERACTIONS_FAILED:
      return Object.assign({}, state, {
        ...state,
        performance: {
          ...state.performance,
          interactions: {
            loading: false,
            error: action.payload,
            item: [],
          },
        },
      });
    case FETCHING_PERFORMANCE_SUMMARY_REQUEST:
      return Object.assign({}, state, {
        ...state,
        performance: {
          ...state.performance,
          performanceSummary: {
            loading: true,
            error: null,
          },
        },
      });

    case FETCHING_PERFORMANCE_SUMMARY_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        performance: {
          ...state.performance,
          performanceSummary: {
            loading: false,
            error: null,
            item: action.payload,
          },
        },
      });

    case FETCHING_PERFORMANCE_SUMMARY_FAILED:
      return Object.assign({}, state, {
        ...state,
        performance: {
          ...state.performance,
          performanceSummary: {
            loading: false,
            error: action.payload,
            item: null,
          },
        },
      });
    case FETCHING_PERFORMANCE_LEADS_GRAPH_REPORT:
      return Object.assign({}, state, {
        ...state,
        performance: {
          ...state.performance,
          leads: {
            loading: true,
            error: null,
            item: [],
          },
        },
      });

    case FETCHING_PERFORMANCE_LEADS_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        performance: {
          ...state.performance,
          leads: {
            loading: false,
            error: null,
            item: action.payload,
          },
        },
      });
    case FETCHING_PERFORMANCE_LEADS_FAILED:
      return Object.assign({}, state, {
        ...state,
        performance: {
          ...state.performance,
          leads: {
            loading: false,
            error: action.payload,
            item: [],
          },
        },
      });
    case FETCHING_PERFORMANCE_DEALS_GRAPH_REPORT:
      return Object.assign({}, state, {
        ...state,
        performance: {
          ...state.performance,
          deals: {
            loading: true,
            error: null,
            item: [],
          },
        },
      });

    case FETCHING_PERFORMANCE_DEALS_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        performance: {
          ...state.performance,
          deals: {
            loading: false,
            error: null,
            item: action.payload,
          },
        },
      });
    case FETCHING_PERFORMANCE_DEALS_FAILED:
      return Object.assign({}, state, {
        ...state,
        performance: {
          ...state.performance,
          deals: {
            loading: false,
            error: action.payload,
            item: [],
          },
        },
      });

    case FETCHING_PERFORMANCE_DEAL_VALUE_GRAPH_REPORT:
      return Object.assign({}, state, {
        ...state,
        performance: {
          ...state.performance,
          dealValue: {
            loading: true,
            error: null,
            item: [],
          },
        },
      });

    case FETCHING_PERFORMANCE_DEAL_VALUE_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        performance: {
          ...state.performance,
          dealValue: {
            loading: false,
            error: null,
            item: action.payload,
          },
        },
      });
    case FETCHING_PERFORMANCE_DEAL_VALUE_FAILED:
      return Object.assign({}, state, {
        ...state,
        performance: {
          ...state.performance,
          dealValue: {
            loading: false,
            error: action.payload,
            item: [],
          },
        },
      });

    case FETCHING_PERFORMANCE_CLOSED_DEALS_GRAPH_REPORT:
      return Object.assign({}, state, {
        ...state,
        performance: {
          ...state.performance,
          closedDeals: {
            loading: true,
            error: null,
            item: [],
          },
        },
      });

    case FETCHING_PERFORMANCE_CLOSED_DEALS_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        performance: {
          ...state.performance,
          closedDeals: {
            loading: false,
            error: null,
            item: action.payload,
          },
        },
      });

    case FETCHING_PERFORMANCE_CLOSED_DEALS_FAILED:
      return Object.assign({}, state, {
        ...state,
        performance: {
          ...state.performance,
          closedDeals: {
            loading: false,
            error: action.payload,
            item: [],
          },
        },
      });

    case FETCHING_PERFORMANCE_CLOSED_DEAL_VALUE_GRAPH_REPORT:
      return Object.assign({}, state, {
        ...state,
        performance: {
          ...state.performance,
          closedDealValue: {
            loading: true,
            error: null,
            item: [],
          },
        },
      });

    case FETCHING_PERFORMANCE_CLOSED_DEAL_VALUE_SUCCEEDED:
      return Object.assign({}, state, {
        ...state,
        performance: {
          ...state.performance,
          closedDealValue: {
            loading: false,
            error: null,
            item: action.payload,
          },
        },
      });
    case FETCHING_PERFORMANCE_CLOSED_DEAL_VALUE_FAILED:
      return Object.assign({}, state, {
        ...state,
        performance: {
          ...state.performance,
          closedDealValue: {
            loading: false,
            error: action.payload,
            item: [],
          },
        },
      });
    case FETCHING_PERFORMANCE_TOP_LEADS_CONTENT:
      return Object.assign({}, state, {
        ...state,
        performance: {
          ...state.performance,
          topLeadsContent: {
            ...state.performance.topLeadsContent,
            loading: true,
            invalidated: true,
          },
        },
      });

    case FETCHING_PERFORMANCE_TOP_LEADS_CONTENT_SUCCEDDED:
      var items = [];

      if (action.payload.currentPage !== 0) {
        items = [
          ...state.performance.topLeadsContent.items,
          ...action.payload.records,
        ];
      } else {
        items = action.payload.records;
      }

      items = _.uniqBy(items, "id");

      return Object.assign({}, state, {
        ...state,
        performance: {
          ...state.performance,
          topLeadsContent: {
            ...state.performance.topLeadsContent,
            loading: false,
            invalidated: false,
            items: items,
            pagination: {
              currentPage: action.payload.currentPage,
              totalPages: action.payload.totalPages,
              recordsPerPage: action.payload.recordsPerPage,
              totalRecordsCount: action.payload.totalRecordsCount,
            },
          },
        },
      });

    case FETCHING_PERFORMANCE_TOP_LEADS_CONTENT_FAILED:
      return Object.assign({}, state, {
        ...state,
        performance: {
          ...state.performance,
          topLeadsContent: {
            ...state.performance.topLeadsContent,
            loading: false,
            invalidated: false,
            error: action.payload.error,
          },
        },
      });

    case FETCHING_PERFORMANCE_TOP_CONTENT_CLOSED_DEALS:
      return Object.assign({}, state, {
        ...state,
        performance: {
          ...state.performance,
          contentClosedDeals: {
            ...state.performance.contentClosedDeals,
            loading: true,
            invalidated: true,
          },
        },
      });

    case FETCHING_PERFORMANCE_TOP_CONTENT_CLOSED_DEALS_SUCCEDDED:
      var items = [];

      if (action.payload.currentPage !== 0) {
        items = [
          ...state.performance.contentClosedDeals.items,
          ...action.payload.records,
        ];
      } else {
        items = action.payload.records;
      }

      items = _.uniqBy(items, "id");

      return Object.assign({}, state, {
        ...state,
        performance: {
          ...state.performance,
          contentClosedDeals: {
            ...state.performance.contentClosedDeals,
            loading: false,
            invalidated: false,
            items: items,
            pagination: {
              currentPage: action.payload.currentPage,
              totalPages: action.payload.totalPages,
              recordsPerPage: action.payload.recordsPerPage,
              totalRecordsCount: action.payload.totalRecordsCount,
            },
          },
        },
      });

    case FETCHING_PERFORMANCE_TOP_CONTENT_CLOSED_DEALS_FAILED:
      return Object.assign({}, state, {
        ...state,
        performance: {
          ...state.performance,
          contentClosedDeals: {
            ...state.performance.contentClosedDeals,
            loading: false,
            invalidated: false,
            error: action.payload.error,
          },
        },
      });

    case FETCHING_CLOSED_DEALS_DETAIL_REPORT:
      return Object.assign({}, state, {
        ...state,
        performance: {
          ...state.performance,
          closedDealsDetail: {
            ...state.performance.closedDealsDetail,
            loading: true,
            invalidated: true,
          },
        },
      });

    case FETCHING_CLOSED_DEALS_DETAIL_REPORT_SUCCEEDED:
      var items = [];

      if (action.payload.currentPage !== 0) {
        items = [
          ...state.performance.closedDealsDetail.items,
          ...action.payload.records,
        ];
      } else {
        items = action.payload.records;
      }

      items = _.uniqBy(items, "id");

      return Object.assign({}, state, {
        ...state,
        performance: {
          ...state.performance,
          closedDealsDetail: {
            ...state.performance.closedDealsDetail,
            loading: false,
            invalidated: false,
            items: items,
            pagination: {
              currentPage: action.payload.currentPage,
              totalPages: action.payload.totalPages,
              recordsPerPage: action.payload.recordsPerPage,
              totalRecordsCount: action.payload.totalRecordsCount,
            },
          },
        },
      });

    case FETCHING_CLOSED_DEALS_DETAIL_REPORT_FAILED:
      return Object.assign({}, state, {
        ...state,
        performance: {
          ...state.performance,
          closedDealsDetail: {
            ...state.performance.closedDealsDetail,
            loading: false,
            invalidated: false,
            error: action.payload.error,
          },
        },
      });

    case FETCHING_DEALS_REQUEST_DETAIL_REPORT:
      return Object.assign({}, state, {
        ...state,
        performance: {
          ...state.performance,
          dealsDetail: {
            ...state.performance.dealsDetail,
            loading: true,
            invalidated: true,
          },
        },
      });

    case FETCHING_DEALS_REQUEST_DETAIL_REPORT_SUCCEEDED:
      var items = [];

      if (action.payload.currentPage !== 0) {
        items = [
          ...state.performance.dealsDetail.items,
          ...action.payload.records,
        ];
      } else {
        items = action.payload.records;
      }

      items = _.uniqBy(items, "id");

      return Object.assign({}, state, {
        ...state,
        performance: {
          ...state.performance,
          dealsDetail: {
            ...state.performance.dealsDetail,
            loading: false,
            invalidated: false,
            items: items,
            pagination: {
              currentPage: action.payload.currentPage,
              totalPages: action.payload.totalPages,
              recordsPerPage: action.payload.recordsPerPage,
              totalRecordsCount: action.payload.totalRecordsCount,
            },
          },
        },
      });

    case FETCHING_DEALS_REQUEST_DETAIL_REPORT_FAILED:
      return Object.assign({}, state, {
        ...state,
        performance: {
          ...state.performance,
          dealsDetail: {
            ...state.performance.dealsDetail,
            loading: false,
            invalidated: false,
            error: action.payload.error,
          },
        },
      });

    case FETCHING_LEADS_DETAIL_REPORT:
      return Object.assign({}, state, {
        ...state,
        performance: {
          ...state.performance,
          leadsDetail: {
            ...state.performance.leadsDetail,
            loading: true,
            invalidated: true,
          },
        },
      });

    case FETCHING_LEADS_DETAIL_REPORT_SUCCEEDED:
      var items = [];

      if (action.payload.currentPage !== 0) {
        items = [
          ...state.performance.leadsDetail.items,
          ...action.payload.records,
        ];
      } else {
        items = action.payload.records;
      }

      items = _.uniqBy(items, "id");

      return Object.assign({}, state, {
        ...state,
        performance: {
          ...state.performance,
          leadsDetail: {
            ...state.performance.leadsDetail,
            loading: false,
            invalidated: false,
            items: items,
            pagination: {
              currentPage: action.payload.currentPage,
              totalPages: action.payload.totalPages,
              recordsPerPage: action.payload.recordsPerPage,
              totalRecordsCount: action.payload.totalRecordsCount,
            },
          },
        },
      });

    case FETCHING_LEADS_DETAIL_REPORT_FAILED:
      return Object.assign({}, state, {
        ...state,
        performance: {
          ...state.performance,
          leadsDetail: {
            ...state.performance.leadsDetail,
            loading: false,
            invalidated: false,
            error: action.payload.error,
          },
        },
      });

    case UPDATE_FILTERS_IN_REPORTS:
      return Object.assign({}, state, {
        ...state,
        selection: {
          filters: action.payload.filters,
        },
      });

    case FETCH_ALL_FILTERS_REQUEST:
      return Object.assign({}, state, {
        ...state,
        filters: {
          ...state.filters,
          loading: true,
          invalidated: true,
        },
      });

    case FETCHING_ALL_FILTERS_SUCCEEDED:
      var records = action.payload.records;
      var items = [];

      if (action.payload.currentPage !== 0) {
        items = [...state.filters.items, ...action.payload.records];
      } else {
        items = action.payload.records;
      }

      var loadMore = action.payload.currentPage <= action.payload.totalPages;

      return Object.assign({}, state, {
        ...state,
        filters: {
          ...state.filters,
          loading: false,
          invalidated: false,
          items: items,
          currentPage: action.payload.currentPage,
          totalPages: action.payload.totalPages,
          recordsPerPage: action.payload.recordsPerPage,
          totalRecordsCount: action.payload.totalRecordsCount,
          loadMore: loadMore,
        },
      });

    case FETCHING_ALL_FILTERS_FAILED:
      return Object.assign({}, state, {
        ...state,
        filters: {
          ...state.filters,
          loading: false,
          invalidated: false,
          error: action.payload.error,
          currentPage: state.filters.currentPage,
          totalPages: state.filters.totalPages,
          recordsPerPage: state.filters.recordsPerPage,
          totalRecordsCount: state.filters.totalRecordsCount,
          loadMore: true,
        },
      });

    case SELECT_FILTER_REQUEST:
      return Object.assign({}, state, {
        ...state,
        filters: {
          ...state.filters,
          item: action.payload.filter,
        },
      });

      case FETCHING_ACCOUNT_SUMMARY_NUDGES_REQUEST:
        return Object.assign({}, state, {
          ...state,
          reportSummary: {
            loading: true,
            error: null,
          },
      });
  
      case FETCHING_ACCOUNT_SUMMARY_NUDGES_SUCCEDDED: {
        const key = action.key; 
        return Object.assign({}, state, {
          ...state,
          reportSummary: {
              loading: true,
              item: {
                ...state.reportSummary.item,
                [key]: action.payload
              },
              error: null,
            },
        }); 
      }  
  
      case FETCHING_ACCOUNT_SUMMARY_NUDGES_FAILED:
        return Object.assign({}, state, {
          ...state,
            reportSummary: {
              ...state.reportSummary,
              loading: true,
              error: action.payload,
            },
        });
  

    default:
      return state;
  }
}

export { reportReducer };
